"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

const StyledPath = _styledComponents2.default.path.withConfig({
  displayName: "Logo__StyledPath",
  componentId: "sc-1shynb4-0"
})(["fill:", ";"], p => p.color && p.theme.colors[p.color] ? p.theme.colors[p.color] : p.theme.colors.primary);

const Logo = ({ color, size = 36 }) => _react2.default.createElement(
  _Box2.default,
  { as: "svg", viewBox: "0 0 1413.3 1360.3", width: size, height: size },
  _react2.default.createElement("rect", {
    x: "330",
    y: "347.8",
    style: { display: "none", fill: "white" },
    width: "720",
    height: "708"
  }),
  _react2.default.createElement(
    "g",
    { id: "logo_margins", style: { opacity: 0.5 } },
    _react2.default.createElement("rect", { y: "-0.2", style: { fill: "none" }, width: "1413", height: "1360" })
  ),
  _react2.default.createElement(
    "g",
    null,
    _react2.default.createElement(StyledPath, {
      color: color,
      d: "M612.3,280.4c3,2.7,5.7,5.8,8.1,9.1c17.6,25.2,13.6,61.7-9.1,82.8c-25.9,24-65.2,23.8-90-0.1 c-1.1-1-2.1-2-3.3-3c-44.1-36.7-106.5-48.7-166.4-19.6c-57.3,27.7-94.2,92-86.7,151.1c9.4,74.3,56,123.4,128.1,136.2 c69.7,12.4,125-18.9,166.8-68.7c58.6-69.8,112.8-143.5,170.1-214.4c53.3-70.9,100.5-119.3,189.7-142 c170.5-40.9,341.1,85.6,349.3,260.7c3.4,90.8-24.5,160.1-87.5,222.1c-108.2,106.6-447.4,461.1-480.1,461.1 c-31.8,0-207.9-188-226.7-208.4c-24.6-26.6-27.7-62.6-2.2-87.8c25.8-25.5,67-28.5,92.6-2c26.8,25.2,135.3,136.3,137.1,136.3 c0,0,351.4-354.5,393.3-400.2c91.7-99.9,29.8-212.7-47.1-248.2c-64.5-26.9-138.1-9.8-184.1,48.3c-79.3,98.5-152,204.4-241.3,293.1 c-156.2,161-430.1,85-481.5-137.6C103.2,386,231.5,204.6,415.6,204.6C493.9,204.6,561.3,233.8,612.3,280.4z"
    })
  )
);

Logo.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number
};

Logo.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number
};

Logo.WithText = ({ color, width, height }) => {
  return _react2.default.createElement(
    _Box2.default,
    {
      as: "svg",
      width: "1814.669",
      height: "534.666",
      viewBox: "0 0 18903 5569",
      width: width,
      height: height
    },
    _react2.default.createElement(StyledPath, {
      color: color,
      d: "M5487 3499l132-233c22-36 76-31 96-17 11 6 213 154 398 154 112 0 194-70 194-168 0-117-98-207-289-283-241-95-544-283-544-619 0-277 216-557 648-557 292 0 516 148 600 210 34 20 28 70 17 90l-143 216c-20 31-70 56-96 36-25-14-230-168-401-168-101 0-177 67-177 143 0 104 84 182 306 272 219 87 566 258 566 639 0 289-249 580-662 580-365 0-567-151-631-216-28-28-37-39-14-78zm2480-401l-212-461h-3l-209 461h424zm-1145 597l872-1879c8-17 28-31 47-31h28c20 0 39 14 47 31l872 1879c17 36-6 72-47 72h-309c-50 0-73-17-98-70l-100-221h-758l-100 223c-14 33-45 67-100 67h-307c-42 0-64-36-47-72zm2338-1832c3-25 28-45 50-45h45c14 0 39 11 48 28l650 1174h6l650-1174c8-17 33-28 48-28h45c22 0 47 20 51 45l316 1846c6 36-19 62-53 62h-330c-25 0-50-22-53-45l-126-865h-6l-470 878c-9 17-34 31-48 31h-50c-17 0-39-14-47-31l-474-878h-5l-123 865c-3 23-25 45-53 45h-330c-34 0-59-25-54-62l317-1846zm2744 1508c109 0 201-89 201-203 0-111-120-195-229-195h-227v398h254zm-37-759c107 0 196-89 196-200 0-112-90-189-196-189h-218v389h218zm-654-737c0-28 23-53 53-53h652c330 0 601 225 601 517 0 214-193 370-324 440 149 61 375 197 375 453 0 311-277 537-610 537h-693c-30 0-53-25-53-53V1874zm2535 1223l-211-461h-3l-209 461h423zm-1145 597l872-1847c8-17 28-31 47-31h28c19 0 39 14 47 31l872 1847c16 36-6 72-48 72h-309c-51 0-72-17-98-70l-101-221h-757l-100 223c-14 33-45 67-100 67h-307c-41 0-64-36-47-72zm2850-1465h-403c-30 0-53-25-53-53v-303c0-28 23-53 53-53h1250c31 0 53 25 53 53v303c0 28-23 53-53 53h-403v1486c0 28-25 53-53 53h-337c-28 0-53-25-53-53V2230zm956-340c-17-36 5-72 48-72h371c22 0 41 17 47 31l459 1019h18l459-1019c6-14 26-31 48-31h371c42 0 64 36 48 72l-875 1847c-8 17-25 31-48 31h-28c-22 0-39-14-47-31l-869-1847zM3501 1219c-250 0-476 101-640 265l-985 990c-86 81-202 131-330 131-265 0-480-215-480-480s215-480 480-480c128 0 244 50 330 132 10 9 11 11 16 15 35 26 79 42 126 42 117 0 211-95 211-211 0-47-16-91-42-126-2-3-16-18-17-19-164-159-388-257-634-257-503 0-911 408-911 911s408 911 911 911c237 0 453-91 615-239 5-4 17-16 17-16l1025-1028c81-66 185-106 297-106 260 0 472 211 472 472 0 121-46 232-121 316L2556 3724c-26 26-68 26-95 0l-375-375 2 5c-40-39-94-62-154-62-122 0-221 99-221 221 0 61 24 116 64 156l-4-6 650 650c50 50 130 49 179 0l1566-1581c2-2 3-4 5-5 143-160 229-371 229-602 0-500-405-905-905-905z",
      fillRule: "nonzero"
    })
  );
};

exports.default = Logo;